export default {
    stones: [],
    total: 0,
    stone_detail: null,
    stone_selected: null,
    loading: false,
    filters: {
        perPage: 18,
        currentPage: 0,
        search: "",
        last_page: false,
    },
};